import { createContext } from 'react'
import { PopularArticles_popularArticles_articles } from '@apollo-types/PopularArticles'

export const PopularArticlesContext = createContext<
  Partial<PopularArticles_popularArticles_articles[]>
>([])
PopularArticlesContext.displayName = 'PopularArticlesContext'

export const PopularArticlesContextProvider = PopularArticlesContext.Provider
